module.exports = __webpack_public_path__ + "static/img/2_1_1.d1fb70f9.jpg";